import React, { FC } from 'react'

import { Grid, Box, makeStyles } from '@material-ui/core'

import T from 'components/FormattedMessage'
import { playerProfilePalette } from 'lib'
import Point from 'components/Point'

import { PointspreadGraphDrawing, PointspreadGraphLegend } from './components'

type Props = {
  totalPlayerPerformance: number
  totalTeamBonus: number
  totalPenalties: number
}

const useStyles = makeStyles(({ breakpoints, typography }) => {
  return {
    totalPointsLabel: {
      fontSize: 10,
      textTransform: 'uppercase',
      color: '#8EA5C2',
      opacity: .3,
      fontWeight: typography.fontWeightMedium,

      [breakpoints.up('sm')]: {
        fontSize: 12,
      },
    },

    totalPointsValue: {
      color: '#8EA5C2',
      opacity: .5,
    },
  }
})

const PointspreadGraph: FC<Props> = props => {
  const classes = useStyles()

  const {
    totalPlayerPerformance,
    totalTeamBonus,
    totalPenalties,
  } = props

  const totalPoints = totalPlayerPerformance + totalTeamBonus + totalPenalties

  return (
    <Grid container>
      <Grid
        item
        xs={5}
        sm={4}
      >
        <Box
          mr={{
            xs: 2,
            sm: 4,
          }}
        >
          <PointspreadGraphDrawing {...props} />
        </Box>
      </Grid>

      <Grid
        item
        xs={7}
        sm={8}
        container
        direction="column"
      >
        <Grid
          item
          xs
          container
          alignItems="center"
        >
          <Grid
            item
            xs={5}
            className={classes.totalPointsLabel}
          >
            <T id="playerprofile_pointspread_totalscore" />
          </Grid>

          <Grid
            item
            xs={7}
            className={classes.totalPointsValue}
          >
            <Point
              isCentered
              value={totalPoints}
            />
          </Grid>
        </Grid>
        <Grid item>
          <PointspreadGraphLegend
            color={playerProfilePalette.playerPerformance[0]}
            points={totalPlayerPerformance}
            title={<T id="playerprofile_player_performance" />}
          />

          <PointspreadGraphLegend
            color={playerProfilePalette.teamBonus[0]}
            points={totalTeamBonus}
            title={<T id="playerprofile_team_bonus" />}
          />

          <PointspreadGraphLegend
            color={playerProfilePalette.penalties[0]}
            points={totalPenalties}
            title={<T id="playerprofile_penalties" />}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default PointspreadGraph
try {
    // @ts-ignore
    PointspreadGraph.displayName = "PointspreadGraph";
    // @ts-ignore
    PointspreadGraph.__docgenInfo = { "description": "", "displayName": "PointspreadGraph", "props": { "totalPlayerPerformance": { "defaultValue": null, "description": "", "name": "totalPlayerPerformance", "required": true, "type": { "name": "number" } }, "totalTeamBonus": { "defaultValue": null, "description": "", "name": "totalTeamBonus", "required": true, "type": { "name": "number" } }, "totalPenalties": { "defaultValue": null, "description": "", "name": "totalPenalties", "required": true, "type": { "name": "number" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/PlayerLayer/components/PlayerProfile/tabs/PointspreadTab/components/PointspreadGraph/PointspreadGraph.tsx#PointspreadGraph"] = { docgenInfo: PointspreadGraph.__docgenInfo, name: "PointspreadGraph", path: "src/components/PlayerLayer/components/PlayerProfile/tabs/PointspreadTab/components/PointspreadGraph/PointspreadGraph.tsx#PointspreadGraph" };
}
catch (__react_docgen_typescript_loader_error) { }